import { api } from "@/api";

/**
 * A read-only live view of a lane's gate kiosk, for an iframe in the camera
 * popover. The URL carries a signed token (valid for 12 h) because a frame
 * cannot send the bearer header.
 */
export const getKioskViewUrl = async (laneId: string) => {
  const { body } = await api.post<{ url: string }>(
    `/storage/lanes/${laneId}/view-url`,
  );
  return body.url;
};
